import React, { FunctionComponent } from "react";
import { makeStyles } from "tss-react/mui";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Theme,
    Typography,
} from "@mui/material";
import MuiDialogTitle from "@mui/material/DialogTitle";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import { FETCHING_DATA_START } from "@/Redux/Disposition/Constants";
import { useAppDispatch, useAppSelector } from "@/Redux/Redux";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";

interface DispositionLoadingErrorProps {
    open: boolean;
    handleClose: () => void;
}

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },

    submit: {
        margin: theme.spacing(3, 0, 2),
    },

    buttonProgress: {
        position: "absolute",
        top: "54%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },

    wrapper: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(2),
        position: "relative",
    },
}));

const DispositionLoadingErrorModal: FunctionComponent<
    DispositionLoadingErrorProps
> = ({ open, handleClose }): JSX.Element => {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { dispositionStartdate, dispositionEnddate } = useAppSelector(
        (state) => state.disposition,
    );

    return (
        <Dialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            maxWidth={"xs"}
        >
            <MuiDialogTitle className={classes.root}>
                <Typography variant="h6">Fehlgeschlagen</Typography>
            </MuiDialogTitle>
            <DialogContent style={{ textAlign: "center" }}>
                <ReportProblemOutlinedIcon
                    style={{ fontSize: 100, color: "red" }}
                />
                <Typography gutterBottom>
                    {t("disposition.loading.loadingDataError")}
                </Typography>
            </DialogContent>
            <DialogActions>
                <div className={classes.wrapper}>
                    <Button
                        onClick={() => {
                            dispatch({
                                type: FETCHING_DATA_START,
                                payload: {
                                    dispositionStartdate,
                                    dispositionEnddate,
                                },
                            });
                            handleClose();
                        }}
                        size={"small"}
                        color="secondary"
                        variant={"outlined"}
                        className={classes.submit}
                    >
                        Dispo neu laden
                    </Button>
                </div>
                <div className={classes.wrapper}>
                    <Button
                        onClick={handleClose}
                        size={"small"}
                        color="primary"
                        variant={"outlined"}
                        className={classes.submit}
                    >
                        OK
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
};

export default DispositionLoadingErrorModal;
